<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-card>
        <v-container>
            <v-layout full-height row wrap>
                <v-flex xs12>
                    <v-layout full-height wrap>
                        <div class="media-logo">
                            <v-img
                                    :src="item.media.logoLink"
                                    width="50px"
                                    height="50px"
                                    class="clickable"
                                    @click="onJournalClicked(item)"
                            ></v-img>
                        </div>
                        <div class="media-meta">
                            <strong class="clickable" @click="onJournalClicked(item)">{{ item.media.name }}</strong><br>
                            <span>{{ item.type }}</span>
                            <span> &bull; </span>
                            <span>{{ item.publishDate | customDate }}</span>
                        </div>
                        <v-spacer></v-spacer>
                        <v-btn v-if="allowDelete"
                               fab
                               small
                               flat
                               @click="deleteJournal(item.id)"
                        >
                            <v-icon light>delete</v-icon>
                        </v-btn>
                    </v-layout>
                </v-flex>
                <v-flex>
                    <br>
                </v-flex>
                <v-flex xs12>
                    <v-layout row wrap>
                        <v-flex lg3 md4 sm4
                                v-for="(page, index) in item.pages"
                                v-if="showPage(index)"
                                @click="onJournalClicked(item)"
                                :key="index"
                                class="clickable"
                        >
                            <v-badge left overlap v-if="showPage(index + 1)">
                                <template v-slot:badge>
                                    <span class="image-index-label">{{ page.pageNo }}</span>
                                </template>
                                <div class="page-image-container">
                                    <img :src="page.cimageLink" class="page-image">
                                </div>
                            </v-badge>
                            <div class="page-image show-more" v-if="showMore(index)">
                                <div class="align-center">
                                    <v-icon light x-large color="primary">arrow_forward</v-icon>
                                    <br>
                                    <p class="caption">{{ leftPages }} more pages...</p>
                                </div>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>
        </v-container>
    </v-card>
</template>

<script>
    import {UserService} from "../services/user.services";
    import custom_date from '../mixins/custom_date';
    import current_user from '../mixins/current_user';

    export default {
        name: 'journal-entry',
        props: ['item'],
        
        mixins: [ custom_date, current_user ],

        methods: {
            onJournalClicked(item) {
                this.$emit('journal-clicked', item)
            },
            showPage(index) {
                return index < 4 || index === this.item.pages.length
            },
            showMore(index) {
                return index === 3 && index !== this.item.pages.length - 1
            },
            deleteJournal(id) {
                this.$emit('journal-deleted', id)
            }
        },
        computed: {
            leftPages() {
                return this.item.pages.length - 3;
            },

            allowDelete() {
                return this.isSuperAdmin || this.isScanningAdmin;
            }
        }
    }
</script>

<style scoped>
    .media-meta {
        margin-left: 15px;
        margin-right: 15px;
    }

    .media-logo {
        margin-left: 4px;
    }

    .page-image-container {
        display: table;
    }

    .page-image {
        width: 100%;
        height: 220px;
        object-fit: cover;
        padding: 5px
    }

    .show-more {
        position: relative;
        border: 3px #26AFDC dashed;
        cursor: pointer;
    }

    .align-center {
        width: 100%;
        text-align: center;
        margin: 0;
        position: absolute;
        top: 50%;
        -ms-transform: translateY(-50%);
        transform: translateY(-50%);
    }

    .clickable {
        cursor: pointer;
    }
</style>
